import { render, staticRenderFns } from "./offline_order_edit.vue?vue&type=template&id=48e5901e&scoped=true"
import script from "./offline_order_edit.vue?vue&type=script&lang=js"
export * from "./offline_order_edit.vue?vue&type=script&lang=js"
import style0 from "./offline_order_edit.vue?vue&type=style&index=0&id=48e5901e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5901e",
  null
  
)

export default component.exports